module.exports = __webpack_public_path__ + "static/img/Creditagricole.f93c8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Creditagricole.png
// module id = rkgs
// module chunks = 0